<template>
  <div>
    <div v-if="isLoggedIn">
      <form @submit.prevent="sendReciepe" class="mb-3">
        <div class="form-group">
          <label for="name">Reciepe name: </label><br />
          <input
            id="name"
            class="form-control"
            type="text"
            v-model="input.name"
          />
        </div>
        <div class="form-group">
          <label for="description">Description: </label><br />
          <textarea
            class="form-control"
            v-model="input.description"
            id="description"
            cols="30"
            rows="10"
          ></textarea>
        </div>
        <div class="form-group">
          <label for="portions">Portions: </label><br />
          <input
            id="portions"
            class="form-control"
            type="number"
            v-model="input.portions"
          />
        </div>
        <h5>Ingredients:</h5>
        <div
          class="form-group row no-gutters"
          v-for="index in ingredient_number"
          :key="index"
        >
          <div class="col-2">
            <label :for="'amount' + index">Amount: </label><br />
            <input
              type="text"
              class="form-control"
              v-model="input.ingredient_amounts[index]"
              :id="'amount' + index"
            />
          </div>
          <div class="col-2">
            <label :for="'unit' + index">Unit: </label><br />
            <input
              type="text"
              class="form-control"
              v-model="input.ingredient_units[index]"
              :id="'unit' + index"
            />
          </div>
          <div class="col-7">
            <label :for="'name' + index">Name: </label><br />
            <input
              type="text"
              class="form-control"
              v-model="input.ingredient_names[index]"
              :id="'name' + index"
            />
          </div>
          <button
            v-if="ingredient_number > 1"
            type="button"
            class="col-1 btn btn-danger"
            @click="removeIngredient(index)"
            id="removeIngredient"
          >
            x
          </button>
          <br />
          <br />
        </div>
        <button
          class="btn btn-success"
          type="button"
          @click="ingredient_number++"
        >
          Legg til ingrediens
        </button>
        <div class="form-group">
          <label for="directions">Directions: </label><br />
          <textarea
            class="form-control"
            v-model="input.directions"
            id="directions"
            cols="30"
            rows="10"
          ></textarea>
        </div>
        <button class="btn btn-primary" type="submit">
          Lagre oppskrift
        </button>
      </form>
    </div>
    <p v-else>Du har ikke tilgang til denne siden</p>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "reciepe",
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data: function() {
    return {
      isLoggedIn: this.$session.has("token"),
      message: null,
      input: {
        name: null,
        description: null,
        portions: null,
        ingredient_amounts: [null],
        ingredient_names: [null],
        ingredient_units: [null],
        directions: null
      },
      ingredient_number: 1
    };
  },
  computed: {
    ingredient_list() {
      var res = [];
      for (var i = 1; i <= this.ingredient_number; i += 1) {
        res.push({
          amount: this.input.ingredient_amounts[i],
          name: this.input.ingredient_names[i],
          unit: this.input.ingredient_units[i]
        });
      }
      return res;
    }
  },
  created() {
    var d = this.$props.data;
    if (d) {
      this.input.name = d.name;
      this.input.description = d.description;
      this.input.portions = d.portions;
      this.input.directions = d.directions;
      for (var i in d.ingredients) {
        this.input.ingredient_amounts.push(d.ingredients[i].amount);
        this.input.ingredient_names.push(d.ingredients[i].name);
        this.input.ingredient_units.push(d.ingredients[i].unit);
      }
      this.ingredient_number = this.input.ingredient_amounts.length - 1;
    }
  },
  methods: {
    responseCatch(response) {
      console.log(response);
      if (response.error) {
        this.message = "Some error occured, try again. " + response.error;
        return;
      }
      if (!(response.status == 200 || response.status == 201)) {
        this.message =
          "Reciepe not submitted correctly, try again (Response code: " +
          response.status +
          ")";
        return;
      }
      this.message = "Reciepe submitted!";
      this.input = {
        name: null,
        description: null,
        portions: null,
        ingredient_amounts: [],
        ingredient_names: [],
        ingredient_units: [],
        directions: null
      };
      this.ingredient_number = 1;
      this.$emit("posted");
    },
    sendReciepe() {
      this.message = "Sending reciepe";
      var posted_data = {
        name: this.input.name,
        description: this.input.description,
        ingredients: this.ingredient_list,
        directions: this.input.directions,
        portions: this.input.portions
      };

      if (this.$props.data) {
        this.APIput("reciepes/" + this.$props.data.id + "/", posted_data).then(
          response => {
            this.responseCatch(response);
          }
        );
      } else {
        this.APIpost("reciepes/all/", posted_data).then(response => {
          this.responseCatch(response);
        });
      }
    },
    removeIngredient(key) {
      this.input.ingredient_amounts.splice(key, 1);
      this.input.ingredient_units.splice(key, 1);
      this.input.ingredient_names.splice(key, 1);
      this.ingredient_number -= 1;
    }
  }
};
</script>

<style>
#removeIngredient {
  height: 2.6em !important;
  border-radius: 1.3em;
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
  align-self: center;
}
</style>
